import { render } from "./AwardTitle.vue?vue&type=template&id=5ba932ab"
import script from "./AwardTitle.vue?vue&type=script&lang=js"
export * from "./AwardTitle.vue?vue&type=script&lang=js"

import "./AwardTitle.vue?vue&type=style&index=0&id=5ba932ab&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__